import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import "rxjs/add/operator/map";
// import { CommonService } from 'src/app/services/common/common.service';

@Injectable({
  providedIn: 'root'
})
export class HttpWrapperService {
  constructor(
    private httpClient: HttpClient,
    // private commonService: CommonService,
  ) { }

  private getUrl(endpoint: string) {
    return environment.baseUrl + endpoint;
  }

  private getMeasureUrl(endpoint: string) {
    return environment.baseMeasureUrl + endpoint;
  }

  private getV1Url(endpoint: string) {
    return environment.baseUrlV1 + endpoint;
  }

  private getV1MeasureUrl(endpoint: string) {
    return environment.baseMeasureUrlV1 + endpoint;
  }

  public post(endpoint: string, options?: any, options1?: any): Observable<any> {
    let url = this.getUrl(endpoint);
    return this.httpClient.post(url, options, options1);
  }

  public postV1(endpoint: string, options?: any, options1?: any): Observable<any> {
    let url = this.getV1Url(endpoint);
    return this.httpClient.post(url, options, options1);
  }

  public post2V1(endpoint: string, options?: any, options1?: any): Observable<any> {
    let url = this.getV1MeasureUrl(endpoint);
    return this.httpClient.post(url, options, options1);
  }

  public get(endpoint: string, options?: any): Observable<any> {
    let url = this.getUrl(endpoint);
    return this.httpClient.get(url, options);
  }

  public delete(endpoint: string): Observable<any> {
    let url = this.getUrl(endpoint);
    return this.httpClient.delete(url);
  }

  public put(endpoint: string, payload: any): Observable<any> {
    let url = this.getUrl(endpoint);
    return this.httpClient.put(url, payload);
  }

  public post2(endpoint: string, options?: any, options1?: any): Observable<any> {
    let url = this.getMeasureUrl(endpoint);
    return this.httpClient.post(url, options, options1);
  }

  public get2(endpoint: string, options?: any): Observable<any> {
    let url = this.getMeasureUrl(endpoint);
    return this.httpClient.get(url, options);
  }

  public delete2(endpoint: string): Observable<any> {
    let url = this.getMeasureUrl(endpoint);
    return this.httpClient.delete(url);
  }

  public put2(endpoint: string, payload: any): Observable<any> {
    let url = this.getMeasureUrl(endpoint);
    return this.httpClient.put(url, payload);
  }

  hanleHttpError(error: HttpErrorResponse) {
    if (error && error.error && error.error.message) {
      // this.commonService.showErrorToastMsg(error.error.message);
    } else {
      // this.commonService.showErrorToastMsg("Something went wrong. Please try again or later.");
    }
  }
}
